import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import appConstants from './../../../../constants/appConstants'
import env from './../../../../environments/environment'
import './HeaderNavBar.component.scss'

const NAV_ITEMS = [
  { label: 'Home', href: '/' },
  {
    label: 'Insurance',
    href: '#',
    children: [
      { label: 'Health Insurance', href: '/health-insurance' },
      { label: 'Medicare Insurance', href: '/medicare-insurance' },
      { label: 'Life Insurance', href: '/life-insurance' },
      { label: 'Small Business Insurance', href: '/small-business-insurance' },
    ],
  },
  {
    label: 'Why USA Benefits Group',
    href: '#',
    children: [
      { label: 'About Us', href: '/about-us' },
      { label: 'Careers', href: '/careers' },
    ],
  },
  { label: 'Transition Your Agency', href: '/transition-your-agency' },
  { label: 'Resources', href: '/resources' },
  { label: 'Find An Agent', href: '/our-licensed-agents' },
]

const isItemActive = item => {
  const path = window.location.pathname
  if (item.href && item.href !== '#' && path === item.href) return true
  if (item.children) {
    return item.children.some(child => path === child.href)
  }
  return false
}

const HeaderNavBar = () => {
  const [drawerOpen, setDrawerOpen] = useState(false)
  const [expandedItems, setExpandedItems] = useState({})

  const toggleExpanded = label => {
    setExpandedItems(prev => ({ ...prev, [label]: !prev[label] }))
  }

  const closeDrawer = () => {
    setDrawerOpen(false)
    setExpandedItems({})
  }

  const logoImg = `https://firebasestorage.googleapis.com/v0/b/${env.integrations.firebase.config.storageBucket}/o/static%2Flogos%2Flogo.usabg-amerilife-website.jpg?alt=media`

  return (
    <>
      <div className='header-nav-bar'>
        <div className='header-nav-bar__inner'>
          <div className='header-nav-bar__logo'>
            <Link to='/'>
              <img src={logoImg} alt='USA Benefits Group' width='32' height='9' />
            </Link>
          </div>

          <nav className='header-nav-bar__nav' role='navigation'>
            <ul className='header-nav-bar__menu' role='menubar'>
              {NAV_ITEMS.map(item => (
                <li
                  key={item.label}
                  className={`header-nav-bar__menu-item${
                    item.children ? ' header-nav-bar__menu-item--has-dropdown' : ''
                  }${isItemActive(item) ? ' header-nav-bar__menu-item--active' : ''}`}
                  role='menuitem'
                  aria-haspopup={item.children ? 'true' : undefined}
                >
                  <a
                    href={item.href}
                    className='header-nav-bar__menu-link'
                    onClick={item.children ? e => e.preventDefault() : undefined}
                  >
                    <span className='header-nav-bar__menu-text'>{item.label}</span>
                    {item.children && (
                      <span className='header-nav-bar__chevron'>
                        <svg width='10' height='6' viewBox='0 0 10 6' xmlns='http://www.w3.org/2000/svg'>
                          <path
                            d='M1 1l4 4 4-4'
                            stroke='currentColor'
                            strokeWidth='1.5'
                            fill='none'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                          />
                        </svg>
                      </span>
                    )}
                  </a>
                  {item.children && (
                    <ul className='header-nav-bar__dropdown' role='menu'>
                      {item.children.map(child => (
                        <li key={child.label} role='menuitem'>
                          <a href={child.href} className='header-nav-bar__dropdown-link'>
                            {child.label}
                          </a>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
          </nav>

          <div className='header-nav-bar__brand-stack'>
            <div className='header-nav-bar__seal-col'>
              <img
                className='header-nav-bar__badge header-nav-bar__badge--1988'
                src={appConstants.badges.experience}
                alt='USA Benefits Group "Established 1988" seal'
              />
            </div>

            <div className='header-nav-bar__trust-col'>
              <img
                className='header-nav-bar__badge'
                src={appConstants.badges.bbb}
                alt='BBB Accredited Business logo, blue and white, with an A+ rating.'
              />
              <a href='/our-licensed-agents' className='header-nav-bar__cta' target='_blank' rel='noopener noreferrer'>
                <span className='header-nav-bar__cta-text'>Get A Quote</span>
              </a>
            </div>
          </div>

          <div className='header-nav-bar__hamburger'>
            <button
              className='header-nav-bar__hamburger-btn'
              aria-controls='hamburger-drawer'
              aria-expanded={drawerOpen}
              onClick={() => setDrawerOpen(!drawerOpen)}
            >
              <svg width='30' height='30' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M3.6 10.8h92.8c2 0 3.6 1.6 3.6 3.6s-1.6 3.6-3.6 3.6H3.6C1.6 18 0 16.4 0 14.4s1.6-3.6 3.6-3.6zm0 35.7h92.8c2 0 3.6 1.6 3.6 3.6s-1.6 3.6-3.6 3.6H3.6C1.6 53.7 0 52.1 0 50.1s1.6-3.6 3.6-3.6zm0 35.7h92.8c2 0 3.6 1.6 3.6 3.6s-1.6 3.6-3.6 3.6H3.6C1.6 89.4 0 87.8 0 85.8s1.6-3.6 3.6-3.6z'
                  fill='currentColor'
                />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {drawerOpen && <div className='header-nav-bar__drawer-overlay' onClick={closeDrawer} />}
      <div
        id='hamburger-drawer'
        className={`header-nav-bar__drawer ${drawerOpen ? 'header-nav-bar__drawer--open' : ''}`}
      >
        <div className='header-nav-bar__drawer-header'>
          <button className='header-nav-bar__drawer-close' onClick={closeDrawer}>
            <svg width='24' height='24' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'>
              <path
                d='M82 87.9c1.6 1.6 4.3 1.6 5.9 0 1.6-1.6 1.6-4.3 0-5.9L55.5 49.6l32.4-32.4c1.6-1.6 1.6-4.3 0-5.9-1.6-1.6-4.3-1.6-5.9 0L49.6 43.7 17.2 11.3c-1.6-1.6-4.3-1.6-5.9 0-1.6 1.6-1.6 4.3 0 5.9l32.4 32.4-32.4 32.4c-1.6 1.6-1.6 4.3 0 5.9 1.6 1.6 4.3 1.6 5.9 0l32.4-32.4L82 87.9z'
                fill='currentColor'
                fillRule='evenodd'
              />
            </svg>
          </button>
        </div>
        <nav className='header-nav-bar__drawer-nav'>
          <ul>
            {NAV_ITEMS.map(item => (
              <li
                key={item.label}
                className={
                  [
                    item.children ? 'header-nav-bar__drawer-item--has-children' : '',
                    isItemActive(item) ? 'header-nav-bar__drawer-item--active' : '',
                  ]
                    .filter(Boolean)
                    .join(' ') || undefined
                }
              >
                {item.children ? (
                  <button
                    className='header-nav-bar__drawer-toggle'
                    onClick={() => toggleExpanded(item.label)}
                    aria-expanded={!!expandedItems[item.label]}
                  >
                    <span>{item.label}</span>
                    <svg
                      className={`header-nav-bar__drawer-chevron${
                        expandedItems[item.label] ? ' header-nav-bar__drawer-chevron--open' : ''
                      }`}
                      width='12'
                      height='8'
                      viewBox='0 0 10 6'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M1 1l4 4 4-4'
                        stroke='currentColor'
                        strokeWidth='1.5'
                        fill='none'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                    </svg>
                  </button>
                ) : (
                  <a href={item.href} className='header-nav-bar__drawer-link'>
                    {item.label}
                  </a>
                )}
                {item.children && (
                  <ul
                    className={`header-nav-bar__drawer-subnav${
                      expandedItems[item.label] ? ' header-nav-bar__drawer-subnav--open' : ''
                    }`}
                  >
                    {item.children.map(child => (
                      <li key={child.label}>
                        <a href={child.href} className='header-nav-bar__drawer-link'>
                          {child.label}
                        </a>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </nav>
        <div className='header-nav-bar__drawer-badges'>
          <img
            className='header-nav-bar__drawer-badge header-nav-bar__drawer-badge--1988'
            src={appConstants.badges.experience}
            alt='USA Benefits Group "Established 1988" seal'
          />
          <img
            className='header-nav-bar__drawer-badge'
            src={appConstants.badges.bbb}
            alt='BBB Accredited Business logo, blue and white, with an A+ rating.'
          />
        </div>
        <div className='header-nav-bar__drawer-footer'>
          <Link to='/' className='header-nav-bar__drawer-footer-logo' onClick={closeDrawer}>
            <img
              src={`https://firebasestorage.googleapis.com/v0/b/${env.integrations.firebase.config.storageBucket}/o/static%2Flogos%2Flogo.usabg-amerilife-plain.md.jpg?alt=media`}
              alt='USA Benefits Group - Health, Life, Senior Insurance'
            />
          </Link>
          <div className='header-nav-bar__drawer-contact'>
            <span>
              Corporate Phone:{' '}
              <a href='tel:18888261966' className='header-nav-bar__drawer-contact-link'>
                1-888-826-1966
              </a>
            </span>
            <span>
              Corporate Email:{' '}
              <a href='mailto:support@usabg.com' className='header-nav-bar__drawer-contact-link'>
                support@usabg.com
              </a>
            </span>
            <span>Corporate Office: 5141 Mariner Blvd, Spring Hill, FL 34609</span>
          </div>
        </div>
      </div>
    </>
  )
}

export default HeaderNavBar
